import { FC } from 'react'

import { SequenceMenu } from '@sequencehq/core-components'

import { MenuItemCancelManualTask } from './CancelManualTask.menuItem'

export const MenuManualTaskActions: FC<{ taskId: string }> = ({ taskId }) => {
  return (
    <SequenceMenu
      variant="ghost"
      buttonSize="medium"
      alignment="bottom-right"
      items={[
        <MenuItemCancelManualTask key="cancel-manual-task" taskId={taskId} />
      ]}
    />
  )
}
